import React from 'react';
import { ResetPasswordForm } from '../../components/forms';

const ResetPasswordPage: React.FC = () => {
  return (
    <div className='h-full flex flex-col justify-center w-full max-w-[27.5rem] mx-auto py-12'>
      <h2 className='!text-4xl !font-medium mb-1 text-secondary-500'>
        Enter new password
      </h2>
      <p className='text-sm mb-6'>
        Please create a new, unique password for your account.
      </p>

      <ResetPasswordForm />
    </div>
  );
};

export default ResetPasswordPage;
